import { createUseStyles } from 'react-jss'
import { GRAY_80, LIGHT_BLUE, RED, RED_70 } from '@omnilert/components'
 
export default createUseStyles({
  addSubmitContainer: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 667px)': {
      flexDirection: 'column'
    }
  },
  phoneNumberInput: {
    backgroundColor: 'red !important',
    width: '100% !important',
    height: '48px !important',
    margin: '10px 0'
  },
  buttonAdd: {
    width: 'auto !important',
    '@media (max-width: 667px)': {
      marginBottom: '20px'
    }
  },
  buttonDelete: {
    border: 'none !important',
    boxShadow: 'none !important',
    width: '48px !important',
    height: '48px !important',
    marginLeft: '5px'
  },
  iconMinus: {
    '--icon__primary__stroke__color': RED,
    '&: hover': {
      '--icon__primary__stroke__color': RED_70
    }
  },
  timerButton: {
    marginTop: '45px'
  },
  field: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  customTextarea: {
    borderRadius: '4.56px !important',
    letterSpacing: '-0.02em !important',
    overflowY: 'auto',
    '&:first-child': { marginRight: '5px' },
    '&:focus': {
      border: `2px solid ${LIGHT_BLUE} !important`
    }
  },
  contactForm: {
    width: '100%',
    height: '100%'
  },
  contactsButtonTitle: {
    fontSize: '18px'
  },
  message: {
    alignItems: 'center',
    backgroundColor: GRAY_80,
    borderRadius: '3px',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    padding: '0 35px',
    width: '100%'
  },
  responsive: {
    display: 'flex',
    justifyContent: 'flex-start !important',
    flexDirection: 'column',
    width: '100% !important'
  },
  text: {
    padding: '20px 0'
  }
})

